import { CaseData } from 'app/types-shared';

export const mapCaseNumber = (caseData: CaseData): number => caseData && caseData.fields &&
  caseData.fields.CaseNo && caseData.fields.CaseNo.values &&
  caseData.fields.CaseNo.values[0] && caseData.fields.CaseNo.values[0].v || undefined;
